// File: FishListRow.jsx
import React from "react";
import { FaEdit } from "react-icons/fa";
import { formatPhone } from "../../utils";

const FishListRow = ({
  fish,
  isEditing,
  editingValues,
  handleCellClick,
  handleInputChange,
  handleSaveClick,
  handleCancelClick,
  handleEditClick,
  isSelected,
  handleCheckboxChange,
  showCheckbox = true,
  showActions = true,
  isClickable = true,
  handleCellClickDestination = null
}) => {
  return (
    <tr key={fish.id} className="hover:bg-gray-100">
      {/* Checkbox for multi-select */}
      {showCheckbox && (
        <td className="px-4 py-2 border-b text-sm text-gray-800">
          <input
            type="checkbox"
            onChange={() => handleCheckboxChange(fish.id)}
            checked={isSelected(fish.id)}
          />
        </td>
      )}

      {/*Needed to customize different order of the columns for segmentReview, using handleCecllClickDestination to know*/}
      {handleCellClickDestination !== 'members' ? (
        <>
          <td 
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id, handleCellClickDestination)}
          >
            {(fish.fishProfiles && fish.fishProfiles.length > 0) ? fish.fishProfiles[0].email || "N/A" : "N/A"}
          </td>

          <td
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id)}
          >
            {(fish.fishProfiles && fish.fishProfiles.length > 0) ? fish.fishProfiles[0].fName || "N/A" : "N/A"}
          </td>

          <td
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id)}
          >
            {(fish.fishProfiles && fish.fishProfiles.length > 0) ? fish.fishProfiles[0].lName || "N/A" : "N/A"}
          </td>

          <td
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id)}
          >
            {isEditing && showActions ? (
              <input
                type="text"
                className="border border-gray-300 rounded px-2 py-1"
                value={editingValues.phoneNumber}
                onChange={(e) => handleInputChange(e, "phoneNumber")}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              formatPhone(fish.phoneNumber) || "N/A"
            )}
          </td>
        </>
      ) : (
        <>
          <td
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id)}
          >
            {(fish.fishProfiles && fish.fishProfiles.length > 0) ? fish.fishProfiles[0].fName || "N/A" : "N/A"}
          </td>

          <td
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id)}
          >
            {(fish.fishProfiles && fish.fishProfiles.length > 0) ? fish.fishProfiles[0].lName || "N/A" : "N/A"}
          </td>

          <td
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id)}
          >
            {isEditing && showActions ? (
              <input
                type="text"
                className="border border-gray-300 rounded px-2 py-1"
                value={editingValues.phoneNumber}
                onChange={(e) => handleInputChange(e, "phoneNumber")}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              formatPhone(fish.phoneNumber) || "N/A"
            )}
          </td>

          <td 
            className={`px-4 py-2 border-b text-sm text-gray-800 ${isClickable ? 'cursor-pointer' : ''}`}
            onClick={() => isClickable && handleCellClick(fish.id, handleCellClickDestination)}
          >
            {(fish.fishProfiles && fish.fishProfiles.length > 0) ? fish.fishProfiles[0].email || "N/A" : "N/A"}
          </td>
        </>
      )}

      {/* Actions cell */}
      {showActions && (
        <td className="px-4 py-2 border-b text-sm text-gray-800">
          {isEditing ? (
            <div className="flex space-x-2">
              <button
                className="text-blue-500 hover:underline"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSaveClick();
                }}
              >
                Save
              </button>
              <button
                className="text-red-500 hover:underline"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCancelClick();
                }}
              >
                Cancel
              </button>
            </div>
          ) : (
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(fish);
              }}
            >
              <FaEdit size={16} />
            </button>
          )}
        </td>
      )}
    </tr>
  );
};

export default FishListRow;
